var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"chat-image-slider mt-2 d-flex flex-wrap"},'div',_vm.$attrs,false),_vm.$listeners),[(!!_vm.previewImageUrl)?_c('v-img',{attrs:{"src":_vm.originalContentUrl,"lazy-src":_vm.previewImageUrl,"max-height":"100","max-width":"100"},on:{"click":function($event){return _vm.showLightBox()}}}):_vm._e(),(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"aoo"}}):_vm._e(),_c('LightBox',{ref:"lightbox",attrs:{"media":[
      {
        thumb: _vm.previewImageUrl,
        src: _vm.originalContentUrl
      }
    ],"showLightBox":false,"siteLoading":"ไม่พบรูปภาพ"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }